import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';

import Button from '../../../components/UI/Button/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import classes from './SwitchAccountsForm.css';
import axios from '../../../axios-local-api';
import Input from '../../../components/UI/Input/Input';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler'
import * as actions from '../../../store/actions/index';
import {
  updateObject,
  checkValidity
} from '../../../shared/utility';

class SwitchAccountsForm extends Component {
  state = {
    adding: false,
    refreshLogs: false,
    addLogForm: {
      accountNumber: {
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: '94917f247ab3'
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false
      }
    },
    formIsValid: false
  }

  formHandler = (event) => {
    event.preventDefault();

    const formData = {};
    for (let formElementIdentifier in this.state.addLogForm) {
      formData[formElementIdentifier] = this.state.addLogForm[formElementIdentifier].value;
    }
    const payload = {
      formData: formData,
      // userId: this.props.userId
    }

    this.props.onInitEquipment(payload);

  }

  inputChangedHandler = (event, inputIdentifier) => {

    const updatedFormElement = updateObject(this.state.addLogForm[inputIdentifier], {
      value: event.target.value,
      valid: checkValidity(event.target.value, this.state.addLogForm[inputIdentifier].validation),
      touched: true
    });
    const updatedSwitchAccountsForm = updateObject(this.state.addLogForm, {
      [inputIdentifier]: updatedFormElement
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedSwitchAccountsForm) {
      formIsValid = updatedSwitchAccountsForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({
      addLogForm: updatedSwitchAccountsForm,
      formIsValid: formIsValid
    });
  }

  render() {
    const formElementsArray = [];
    for (let key in this.state.addLogForm) {
      formElementsArray.push({
        id: key,
        config: this.state.addLogForm[key]
      });
    }
    let form;
    if (this.props.loading) {
      form = (
      <Spinner />
    );
    } else {
      form  = (
        <form onSubmit={this.formHandler}>
                  {formElementsArray.map(formElement => (
                      <Input
                          key={formElement.id}
                          elementType={formElement.config.elementType}
                          elementConfig={formElement.config.elementConfig}
                          value={formElement.config.value}
                          invalid={!formElement.config.valid}
                          shouldValidate={formElement.config.validation}
                          touched={formElement.config.touched}
                          changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                  ))}
                  <Button btnType="Success" disabled={!this.state.formIsValid}>SUBMIT</Button>
              </form>
      );
    }
    return (
      <div className={classes.SwitchAccountsForm}>
                <h2>Enter an Account Number</h2>
                {form}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    adding: false,
    refreshLogs: true,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onInitEquipment: (payload) => dispatch(actions.initEquipment(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(SwitchAccountsForm, axios));
